var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"custom-checkbox",class:[_vm.checkboxType, _vm.checkboxView]},[_c('input',{attrs:{"id":_vm.checkboxId,"type":"checkbox","name":""}}),_vm._v(" "),_c('label',{attrs:{"for":_vm.checkboxId}})])
}
var staticRenderFns = []

export { render, staticRenderFns }